import { render, staticRenderFns } from "./all-department-people-dialog.vue?vue&type=template&id=fc643900"
import script from "./all-department-people-dialog.vue?vue&type=script&lang=js"
export * from "./all-department-people-dialog.vue?vue&type=script&lang=js"
import style0 from "./all-department-people-dialog.vue?vue&type=style&index=0&id=fc643900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports